import axios from '@plugins/axios'
import store from '@state/store'
import config from '@src/app.config'
const env = config.env
const appConfig = config[env]

export const state = {
  projects: {
    results: []
  },
  variablesToRate: {
    results: []
  },
  selectedAreas: {
    results: [],
    count: 0,
  },
  loading: false,
  areasToRate: [],
  changesToRate: [],
  areasRated: {
    results: []
  },
  allAreasRated: {
    data: [],
    ambits: [],
    changes: [],
    columns: {
      fixed: [],
      changes: [],
    },
  },
  variablesSceneriesRated: {
    results: []
  },
  scenerieReportDescription: {
    results: []
  },
  allVariablesData: []
}

export const getters = {
  projects: state => state.projects,
  loading: state => state.loading,
  variablesToRate: state => state.variablesToRate,
  selectedAreas: state => state.selectedAreas,
  areasToRate: state => state.areasToRate,
  changesToRate: state => state.changesToRate,
  areasRated: state => state.areasRated,
  allAreasRated: state => state.allAreasRated,
  allVariablesData: state => state.allVariablesData,
  variablesSceneriesRated: state => state.variablesSceneriesRated,
  scenerieReportDescription: state => state.scenerieReportDescription,
}

export const mutations = {
  SET_PROJECTS(state, projects) {
    state.projects = projects
  },
  SET_VARIABLES_TO_RATE(state, variables) {
    state.variablesToRate = variables
  },
  SET_SELECTED_AREA(state, data) {
    state.selectedAreas = data
  },
  SET_AREAS_CHANGES_TO_RATE(state, payload) {
    state.areasToRate = payload.areas
    state.changesToRate = payload.changes
  },
  SET_AREAS_RATED(state, data) {
    state.areasRated = data
  },
  SET_AREAS_REPORT_DATA(state, payload) {
    state.allAreasRated.data = payload.data || []
    state.allAreasRated.ambits = payload.ambits || []
    state.allAreasRated.changes = payload.changes || []
    state.allAreasRated.columns = payload.columns || {
      fixed: [],
      changes: [],
    }
  },
  SET_VARIABLES_REPORT_DATA(state, data) {
    state.allVariablesData = data
  },
  SET_VARIABLES_SCENERIES_RATED_REPORT(state, data) {
    state.variablesSceneriesRated = data
  },
  SET_VARIABLES_SCENERIES_RATED_DESC(state, data) {
    state.scenerieReportDescription = data
  },
  SET_LOADING(state, loading) {
    state.loading = loading
  },
}

export const actions = {

  setLoading({ commit }, state){
    commit('SET_LOADING', state)
  },

  fetchProjects({ commit }, username) {
    commit('SET_LOADING', true)
    store.dispatch('utils/loaderMessage', 'Cargando mis proyectos...' )
    axios.get(appConfig.server_url + `/profile_management/profile/?username=${username}`)
      .then(resp => {
        const expertProjects = resp.data.results
          .filter(p => p.role === 1 || p.role === 2)
        const data = {
          results: expertProjects
        }
        store.dispatch('utils/loaderMessage', '' )
        commit('SET_LOADING', false)
        commit('SET_PROJECTS', data)
      })
      .catch(() => {
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: 'Error consultando proyectos' })
        store.dispatch('utils/loaderMessage', '' )
        commit('SET_LOADING', false)
      })
  },
  fetchVariablesToRate({ commit }, payload) {
    const { profileId, projectId } = payload
    axios.get(appConfig.server_url + `/projects_management/factormatrix/?profile_id=${profileId}&project_id=${projectId}`)
      .then(resp => {
        commit('SET_VARIABLES_TO_RATE', resp.data)
      })
      .catch(() => {
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: 'Error consultando variables' })
      })
  },
  rateVariable({ commit }, payload) {
    axios.put(appConfig.server_url + `/projects_management/factormatrix/${payload.id}/`, payload)
      .then(resp => {
        if (resp.status === 200 || resp.status === 201) {
          payload.callback()
        }
      })
      .catch(() => {
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: 'Error calificando variable' })
      })
  },
  chooseArea({ commit, dispatch }, payload) {
    axios.post(appConfig.server_url + '/projects_management/suggestedambit/', payload)
      .then(resp => {
        commit('SET_SELECTED_AREA', { selected: true, url: resp.data.ambit })
        dispatch('fetchSelectedArea', { project: payload.project_id, profile: payload.profile_id })
        store.dispatch('utils/message', { type: 'success', title: 'Correcto', text: 'Ámbito elegido correctamente.' })
      })
      .catch(() => {
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: 'Error eligiendo ámbito' })
      })
  },
  fetchSelectedArea({ commit }, payload) {
    const { project, profile } = payload
    axios.get(appConfig.server_url + `/projects_management/suggestedambit/?project_id=${project}&profile_id=${profile}`)
      .then(resp => {
        if (resp.status === 200) {
          commit('SET_SELECTED_AREA', resp.data)
        }
      })
      .catch(() => {
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: 'Error consultando ámbito seleccionado' })
      })
  },
  fetchAreasToRate({ commit }, projectId) {
    axios.get(appConfig.server_url + `/projects_management/getfixture/ambitschange?project_id=${projectId}`)
      .then(resp => {
        if (resp.status === 200) {
          commit('SET_AREAS_CHANGES_TO_RATE', { areas: resp.data.ambits, changes: resp.data.changes })
        }
      })
      .catch(() => {
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: 'Error consultando información para calificar' })
      })
  },
  rateChangeArea({ commit }, payload) {
    axios.post(appConfig.server_url + '/projects_management/changefactormatrix/', payload)
      .then(resp => {
        if (resp.status === 200 || resp.status === 201) {
          payload.callback()
        }
      })
      .catch(() => {
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: 'Error calificando ámbito' })
      })
  },
  updateRateChangeArea({ commit }, payload) {
    axios.put(appConfig.server_url + `/projects_management/changefactormatrix/${payload.id}/`, payload)
      .then(resp => {
        if (resp.status === 200 || resp.status === 201) {
          payload.callback()
        }
      })
      .catch(() => {
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: 'Error calificando ámbito' })
      })
  },
  fetchRatedAreas({ commit }, payload) {
    const { project, profile } = payload
    axios.get(appConfig.server_url + `/projects_management/changefactormatrix/?project_id=${project}&profile_id=${profile}`)
      .then(resp => {
        if (resp.status === 200 || resp.status === 201) {
          commit('SET_AREAS_RATED', resp.data)
        }
      })
      .catch(() => {
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: 'Error consultando ámbitos calificados' })
      })
  },
  deleteAreaSelection({ dispatch }, payload) {
    axios.delete(payload.url)
      .then(resp => {
        if (resp.status === 200 || resp.status === 201) {
          dispatch('fetchSelectedArea', { project: payload.project_id, profile: payload.profile_id })
          store.dispatch('utils/message', { type: 'success', title: 'Correcto', text: 'Ámbito eliminado correctamente.' })
        }
      })
      .catch(() => {
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: 'Error eliminando ámbito seleccionado' })
      })
  },
  fetchAllRatedAreas({ commit }, payload) {
    let url = appConfig.server_url + `/projects_management/reports/getfactormatrixfull?project_id=${payload.project}`
    if (payload.detail) {
      url = appConfig.server_url + `/projects_management/reports/getfactormatrixfull-detail?detail=true&project_id=${payload.project}`
    }
    axios.get(url)
      .then(resp => {
        if (resp.status === 200) {
          commit('SET_AREAS_REPORT_DATA', resp.data)
        }
      })
      .catch(() => {
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: 'Error consultando datos de reporte' })
      })
  },
  fetchAllRatedVariables({ commit }, payload) {
    axios.get(appConfig.server_url + `/projects_management/reports/auditchangefactormatrix?project_id=${payload.projectId}`)
      .then(resp => {
        if (resp.status === 200) {
          commit('SET_VARIABLES_REPORT_DATA', resp.data.data)
        }
      })
      .catch(() => {
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: 'Error consultando datos de reporte' })
      })
  },
  fetchSceneriesRated({ commit }, profileId) {
    return axios.get(appConfig.server_url + `/projects_management/scenario/?expert_id=${profileId}`)
      .then(resp => {
        store.commit('projectData/SET_VARIABLES_SCENERIES_RATED', resp.data)
        return resp.data
      })
      .catch((error) => {
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: 'Error consultando escenario' })
        return {'error': true, 'detail': error.message }
      })
  },
  rateScene({ commit, dispatch }, payload) {
    const data = {
      hypothesis: payload.url,
      expert: appConfig.server_url + `/profile_management/profile/${payload.profile_id}/`,
      expert_id: payload.profile_id,
      hypothesis_id: payload.id,
      var_id: payload.var_id
    }
    commit('SET_LOADING', true)
    return axios.post(appConfig.server_url + `/projects_management/scenario/`, data)
      .then(resp => {
        store.dispatch('utils/message', { type: 'success', title: 'Correcto', text: 'Hipótesis seleccionada correctamente.' })
        commit('SET_LOADING', false)
        return resp
      })
      .catch((error) => {
        commit('SET_LOADING', false)
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: 'Error seleccionando hipótesis' })
        return {'error': true, 'detail': error.message }
      })
  },
  updateRateScene({ commit, dispatch }, payload) {
    console.log("payload:", payload)
    const data = {
      hypothesis: payload.hypothesis || payload.url,
      expert: appConfig.server_url + `/profile_management/profile/${payload.profile_id}/`,
      expert_id: payload.profile_id,
      hypothesis_id: payload.id,
    }
    commit('SET_LOADING', true)
    return axios.put(payload.url_to_edit, data)
      .then(resp => {
        store.dispatch('utils/message', { type: 'success', title: 'Correcto', text: 'Hipótesis actualizada correctamente.' })
        commit('SET_LOADING', false)
        return resp
      })
      .catch((error) => {
        commit('SET_LOADING', false)
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: 'Error actualizando hipótesis' })
        return {'error': true, 'detail': error.message }
      })
  },
  saveScene({ dispatch }, payload) {
    // const data = {
    //   project: appConfig.server_url + `/projects_management/project/${payload.project_id}/`,
    //   expert: appConfig.server_url + `/profile_management/profile/${payload.profile_id}/`,
    //   name_scenario: payload.name_scenario
    // }
    const data = {
      project_id: payload.project_id,
      profile_id: payload.profile_id,
      name_scenario: payload.name_scenario
    }
    return axios.post(appConfig.server_url + `/projects_management/scenariodescription/`, data)
      .then(resp => {
        store.dispatch('utils/message', { type: 'success', title: 'Correcto', text: 'Escenario creado correctamente.' })
        return resp.data
      })
      .catch((error) => {
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: 'Error nombrando el escenario, reintente nuevamente' })
        return {'error': true, 'detail': error.message }
      })
  },
  fetchExpertSceneriesReport({ commit }, payload) {
    const { profileId, projectId } = payload
    axios.get(appConfig.server_url + `/projects_management/scenario/?expert_id=${profileId}&project_id=${projectId}`)
      .then(resp => {
        commit('SET_VARIABLES_SCENERIES_RATED_REPORT', resp.data)
      })
      .catch(() => {
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: 'Error realizando acción' })
      })
    axios.get(appConfig.server_url + `/projects_management/scenariodescription/?expert_id=${profileId}&project_id=${projectId}`)
      .then(resp => {
        commit('SET_VARIABLES_SCENERIES_RATED_DESC', resp.data)
      })
      .catch(() => {
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: 'Error realizando acción' })
      })
  },
}
